import { TableRow } from "@mui/material";
import { useTranslation } from "react-i18next";

import { StyledTableHeadingCell } from "../../../../../common/components/functional/simpleTable/styled";

// TODO: causes horizontal overflow
export const PaymentProhibitionRowHeader = () => {
  const { t } = useTranslation();
  return (
    <TableRow>
      <StyledTableHeadingCell>
        {t("talentProfile:start")}
      </StyledTableHeadingCell>
      <StyledTableHeadingCell>{t("talentProfile:end")}</StyledTableHeadingCell>
      <StyledTableHeadingCell sx={{ minWidth: "150px" }}>
        {t("talentProfile:enforcementAgency")}
      </StyledTableHeadingCell>
      <StyledTableHeadingCell sx={{ minWidth: "174px", maxWidth: "180px" }}>
        {t("common:iban").toUpperCase()}
      </StyledTableHeadingCell>
      <StyledTableHeadingCell sx={{ minWidth: "106px" }}>
        {t("common:bic").toUpperCase()}
      </StyledTableHeadingCell>
      <StyledTableHeadingCell sx={{ minWidth: "150px" }}>
        {t("common:referenceNumber")}
      </StyledTableHeadingCell>
      <StyledTableHeadingCell sx={{ minWidth: "200px" }}>
        {t("common:employer")}
      </StyledTableHeadingCell>
      <StyledTableHeadingCell sx={{ minWidth: "50px", maxWidth: "60px" }}>
        {t("talentProfile:otherMonthlyIncome")}
      </StyledTableHeadingCell>
      <StyledTableHeadingCell sx={{ minWidth: "50px", maxWidth: "50px" }}>
        {t("talentProfile:protectedAmount")}
      </StyledTableHeadingCell>
      <StyledTableHeadingCell sx={{ minWidth: "50px", maxWidth: "60px" }}>
        {t("talentProfile:reliefPerMonth")}
      </StyledTableHeadingCell>
      <StyledTableHeadingCell sx={{ minWidth: "160px" }}>
        {t("talentProfile:typeCode")}
      </StyledTableHeadingCell>
      <StyledTableHeadingCell sx={{ minWidth: "50px", maxWidth: "60px" }}>
        {t("talentProfile:sum")}
      </StyledTableHeadingCell>
      <StyledTableHeadingCell />
    </TableRow>
  );
};
